export default {
  getLawList: state => state.lawList,
  getCondition: state => state.condition
};
